import { render, staticRenderFns } from "./documentos-pedido-form.vue?vue&type=template&id=72aae7cc"
import script from "./documentos-pedido-form.vue?vue&type=script&lang=js"
export * from "./documentos-pedido-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports